import { render, staticRenderFns } from "./shareBox.vue?vue&type=template&id=407688f0&scoped=true&"
import script from "./shareBox.vue?vue&type=script&lang=js&"
export * from "./shareBox.vue?vue&type=script&lang=js&"
import style0 from "./shareBox.vue?vue&type=style&index=0&id=407688f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407688f0",
  null
  
)

export default component.exports